import { React, useState } from 'react'
import './PopUpWrapper.css'
import PopUp from '../../components/PopUp/PopUp'
const PopUpWrapper = (props) => {
    const [showPopUp, setShowPopUp] = useState(true)
    if (props.isToast) {
        setTimeout(() => {
            setShowPopUp(false)
        }, 3000)
    }

    return (
        <div>
            {showPopUp ? (
                <PopUp
                    isToast={props.isToast}
                    toastType={props.toastType}
                    setShowPopUp={setShowPopUp}
                    children={props.children}
                    width={props.width}
                    height={props.height}
                    {...props}
                />
            ) : null}
        </div>
    )
}
export default PopUpWrapper
